import tokenManager from "./tokenManager";

const authFetch = async (url, options = {}) => {
  options.credentials = "include";

  const response = await fetch(url, options);

  if (response.status === 401 && !options._retried) {
    try {
      const newToken = await tokenManager.refreshToken();

      if (options.headers) {
        if (options.headers instanceof Headers) {
          options.headers.set("Authorization", `Bearer ${newToken}`);
        } else {
          options.headers["Authorization"] = `Bearer ${newToken}`;
        }
      }

      options._retried = true;
      options.credentials = "include";
      return fetch(url, options);
    } catch (refreshError) {
      return response;
    }
  }

  return response;
};

export default authFetch;
